import { render } from "./DiagnosticsCategoryComponent.vue?vue&type=template&id=2a5e2e34"
import script from "./DiagnosticsCategoryComponent.vue?vue&type=script&lang=js"
export * from "./DiagnosticsCategoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__